module.exports = __webpack_public_path__ + "static/media/makerdao.de37de3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/hackathon/makerdao.png
// module id = 445
// module chunks = 0